import { render, staticRenderFns } from "./form-notification.vue?vue&type=template&id=ef84b54a&scoped=true"
import script from "./form-notification.vue?vue&type=script&lang=js"
export * from "./form-notification.vue?vue&type=script&lang=js"
import style0 from "./form-notification.vue?vue&type=style&index=0&id=ef84b54a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef84b54a",
  null
  
)

export default component.exports